import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import type { Permission } from "@xop/dashboard-shared";
import { BackButton } from "@/components/ui/back-button";

export function Forbidden({
  requiredPermission,
}: {
  requiredPermission: Permission;
}): JSX.Element {
  return (
    <Box component="main" sx={{ mx: "auto", mt: 5, maxWidth: "36rem" }}>
      <Card>
        <CardHeader title="You don't have access to this section" />
        <CardContent>
          <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
            Your account is missing the{" "}
            <Box
              component="code"
              sx={{
                borderRadius: 0.5,
                bgcolor: "surfaceSoft",
                px: 0.5,
                py: 0.25,
                fontSize: 12,
                fontFamily: "ui-monospace, monospace",
              }}
            >
              {requiredPermission}
            </Box>{" "}
            permission. Ask an admin to grant it, or head back to the dashboard.
          </Typography>
          <BackButton to="/" label="Back to dashboard" sx={{ mt: 2 }} />
        </CardContent>
      </Card>
    </Box>
  );
}
